<template>
<div
  class="dropzone"
  :class="{ active: dragActive, danger: errors.files}"
  id="dropzone"
  @dragenter.prevent="toggleDrag"
  @dragleave.prevent="toggleDrag"
  @dragover.prevent=""
  @drop.prevent="dropped" >
  <div class="block is-size-3 ">{{ zoneTitle }}</div>
  <div class="block is-italic">or</div>
  <div class="block"><ChooseFile @choiceMade="chosen" /></div>
  <div class="block is-centered">
  </div>
</div>
</template>

<script>
import { ref } from "vue";
import ChooseFile from './ChooseFile.vue'

export default {
    name: 'DropZone',
    components: { ChooseFile },
    data() {
        return {
            fileName: "silly-name",
            dragCounter: 0,
            files: []
        }
    },
    props: {
        zoneTitle: {type: String, default: "Drag and Drop"},
        errors: {type: Object, default: {}}
    },
    emits: ['choiceMade'],
    methods: {
        toggleDrag(event){
            if (event.type == "dragenter") {
                this.dragCounter = this.dragCounter + 1
            } else if (event.type == "dragleave") {
                this.dragCounter = this.dragCounter - 1
            }
        },
        dropped(event){
            this.dragCounter = 0
            this.choiceMade(event.dataTransfer.files)
        },
        chosen(event){
            this.dragCounter = 0
            this.choiceMade(event.files)
        },
        choiceMade(files) {
            this.dragCounter = 0
            this.$emit("choiceMade", {files: files})
        },
    },
    computed: {
        dragActive(){
            return this.dragCounter > 0
        }
    }
}
</script>

<style>
.dropzone {
    padding: 30px 0;
    border: 2px dashed;
    text-align: center;
    border-radius: 5px;
}

.dropzone.danger {
    border-color: red;
}
.dropzone.active {
    border-color: #252b21 ;
    background-color: #d3e5c7 ;
}
</style>
